import React, {Fragment, useEffect, useState, useContext} from 'react';
import PropTypes from 'prop-types';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import {handleValidateObj} from 'constants/objValues/objvalues';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Inventory from 'components/sales/inventory/inventory';
import {Button, Image} from "react-bootstrap";
import Images from "../../../assets/images/imageData";
import propTypes from "prop-types";
import Layout from "components/sales/layout/layout";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import {toast, ToastContainer} from "react-toastify";
import {BaseUrl} from "contexts/baseUrl/baseUrl";
import {Link} from "react-router-dom";
import ModalPop from "components/sales/modal/modal";
import CardSection from 'components/sales/cardSection/cardSection';
import '../hotoMainForm/hoto.css';

const HotoInstallForm = ({
                           history,
                           getHotoDetails,
                           match,
                           hotoDetails,
                           imageUploadUrlPublic,
                           storeHotoInstallation

                         }) => {

  const [inputList, setInputList] = useState([{ins_remarks: "", ins_image: []}]);
  const [matData, setMatData] = useState();
  const [isTarget, setIsTarget] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [modalMsg, setMessage] = useState('');
  const {baseUrl} = useContext(BaseUrl);
  const [previousIter, setPreviousIter] = useState();
  const [iterCount, setIterCount] = useState();

  useEffect(() => {
    if (hotoDetails && hotoDetails?.currentIter) {
      setInputList(hotoDetails?.currentIter);
      if (hotoDetails?.prevIter) {
        setPreviousIter(hotoDetails?.prevIter);
        setIterCount(hotoDetails?.prevIter.length);
      }
    }
  }, [hotoDetails]);

  useEffect(() => {
    (async () => await getHotoDetails(match.params.id))();
  }, [getHotoDetails]);

  // handle input change
  const handleInputChange = (e, index) => {
    const {name, value} = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };
  const handledropDownChange = (e, index, name) => {
    const {value, id} = e;
    const list = [...inputList];
    list[index][name] = id;
    setInputList(list);
  };

  const handleImageChange = (index, val, name) => {
    const list = [...inputList];
    list[index][name] = val;
    setInputList(list);
  };

  const handleModalHide = async () => {
    setIsModal(false);
    history.push(`${baseUrl}/hoto-isite-listing/1`);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index,imgIndex) => {
    const list = [...inputList];
    const imageList = list[index]['ins_image'];
    imageList.splice(imgIndex, 1);
    list[index]['ins_image'] = imageList;
    setInputList(list);
  };
  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, {ins_remarks: "", ins_image: []}]);
  };

  const handleSubmit = (hoto_id) => {
    // console.log(inputList);return;
    setIsLoading(true);
    let isNotEmpty = true;
    let vali = {};
    {
      inputList.map((x, i) => {
        if (x?.m_mat_status == 'NOT OK') {
          vali = {
            ...vali,
            ins_remarks: x?.ins_remarks,
            ins_image: x?.ins_image
          }
        }
      })
    }
    isNotEmpty = handleValidateObj(vali);
    if (isNotEmpty !== false) {
      (async () => {
        setIsLoading(true);
        var obj = {
          hoto_data: inputList,
          hoto_id: hoto_id
        };
        const res = await storeHotoInstallation(obj);
        if (res) {
          setMessage('Details saved successfully!');
          setIsModal(true);
        } else {
          setMessage('Not Saved!');
          setIsModal(true);
        }
      })();
    } else {
      // toast.error('Please fill all the fields.');
      const active = document.querySelector('.activeAnkInput');
      // console.log(active);
      if(active){
        active.focus();
      }else{
        toast.error('Please fill all the fields & upload all images.');
      }
    }
    setIsLoading(false);
  };

  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">{localization.save}</Button>
        <Button onClick={() => handleSubmit(match.params.id)} /* disabled={isClicked} */>
          {localization.submitDtl} <Image fluid src={Images?.ArrowRight}/>
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      history={history}
      Buttons={handleButtons}
      isGoback
      title={localization.goBack}
    >
      <FormSection title={localization.installHotoForm}>

        {inputList.map((x, i) => {
          return (
            <CardSection title={x.material_name}>
            <div key={i} className="row">
              {/* <div className="col-md-3">
                <ConstantInput
                  label={localization.materialHardware}
                  value={x.material_name}
                  disabled
                />

              </div> */}
              <div className="col-md-2">
                <ConstantInput
                  label={localization.materialHardware}
                  value={x.m_mat_status}
                  disabled
                />
              </div>
              <div className="col-md-2">
                <input
                  className="form-control"
                  name="m_remarks"
                  placeholder="Remarks"
                  value={x.m_remarks}
                  disabled
                />
              </div>
              {x?.m_image &&
                <div class="row img-div">
                  {x.m_image.map((imgdoc, j) => {
                    return (
                      <>
                      <div className="col-md-2">
                        {imgdoc.split('.').pop() === 'png' ? <img src={imgdoc} style={{
                            "width": "80px",
                            "borderRadius": "8px",
                            "height": "57px",
                            "border": "1px solid #555"
                          }}/> :
                          imgdoc.split('.').pop() === 'jpeg' ? <img src={imgdoc} style={{
                              "width": "80px",
                              "borderRadius": "8px",
                              "height": "57px",
                              "border": "1px solid #555"
                            }}/> :
                            imgdoc.split('.').pop() === 'jpg' ? <img src={imgdoc} style={{
                                "width": "80px",
                                "borderRadius": "8px",
                                "height": "57px",
                                "border": "1px solid #555"
                              }}/> :
                              imgdoc.split('.').pop() === 'pdf' ?
                                <img src={Images?.DocIcon} alt="" className="view-icon"/> :
                                imgdoc.split('.').pop() === 'doc' ?
                                  <img src={Images?.DocIcon} alt="" className="view-icon"/> :
                                  ""
                        }
                      </div>
                      </>
                    );
                  })}
                </div>
              }
              {x?.m_mat_status == 'NOT OK' &&
                <>
                  <div className="col-md-3">
                    <input
                      className="form-control activeAnkInput"
                      name="ins_remarks"
                      placeholder="Remarks"
                      value={x.ins_remarks}
                      onChange={e => handleInputChange(e, i)}
                      required
                    />
                  </div>
                  <div>
                    <FileUpload
                      id={"agreementContractUpload" + i}
                      accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.webm,.mkv"
                      documentUploadUrl={imageUploadUrlPublic}
                      onChange={(val) => handleImageChange(i, val, 'ins_image')}
                      showFileName={false}
                      multiple={true}
                    >
                  <span className="btn btn-transparent">
                {localization.image}
                    <span className="label-star" style={{color: 'red'}}>
                  &nbsp; *
                  </span>
                  </span>
                    </FileUpload>
                  </div>
                  {x?.ins_image &&
                    <>
                    <div class="row img-div">
                      {x.ins_image.map((imgdoc, j) => {
                        return (
                          <div className="col-md-2">
                            {
                              imgdoc.split('.').pop() == 'png' ?
                                <img src={imgdoc} style={{
                                  "width": "80px",
                                  "borderRadius": "16px",
                                  "height": "57px"
                                }}/>
                                :
                                imgdoc.split('.').pop() === 'jpeg' ? <img src={imgdoc}
                                                                          style={{
                                                                            "width": "80px",
                                                                            "borderRadius": "16px",
                                                                            "height": "57px"
                                                                          }}/> :
                                  imgdoc.split('.').pop() === 'jpg' ? <img src={imgdoc}
                                                                           style={{
                                                                             "width": "80px",
                                                                             "borderRadius": "16px",
                                                                             "height": "57px"
                                                                           }}/> :
                                    imgdoc.split('.').pop() === 'pdf' ?
                                      <img src={Images?.DocIcon} alt=""
                                           className="view-icon"/> :
                                      imgdoc.split('.').pop() === 'doc' ?
                                        <img src={Images?.DocIcon} alt=""
                                             className="view-icon"/> :
                                        imgdoc.split('.').pop() === 'mp4' ?
                                          <video width="120" height="80" controls>
                                            <source src={imgdoc}
                                                    type="video/mp4"></source>
                                          </video> :
                                          imgdoc.split('.').pop() === 'webm' ?
                                            <video width="120" height="80"
                                                   controls>
                                              <source src={imgdoc}
                                                      type="video/mp4"></source>
                                            </video> :
                                            imgdoc.split('.').pop() === 'mkv' ?
                                              <video width="120" height="80"
                                                     controls>
                                                <source src={imgdoc}
                                                        type="video/mp4"></source>
                                              </video> :
                                              ""
                            }
                          <a className='remover' onClick={() => handleRemoveClick(i,j)}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" class="bi bi-x-circle" viewBox="0 0 16 16">
                           <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                          </svg>
                          </a>
                          </div>
                        );
                      })}
                      </div>  
                    </>
                  }
                </>
              }
            </div>
            </CardSection>
          );
        })}
      </FormSection>

      <br/>
      {/*Previous Hoto Iterations Start*/}
      {
        previousIter &&
        <div className="container-fluid mb-0">
          {previousIter.map((prevIt, key2) => {
            return(
              <div className="card mb-2">
                <div className="card-header mb-3">
                  HOTO Iteration {iterCount-key2}
                  <span className='r-shiwt'>
                  ME: <b>{prevIt?.[0].m_name} ({prevIt?.[0].me_created_at})</b>
                </span>
                  <span className='r-shiwt m-right'>
                  SE: <b>{prevIt?.[0].i_name} ({prevIt?.[0].se_updated_at})</b>
                </span>
                </div>
                <div className="card-body ml-2 mr-2">

                  <table className='panel-table table table-striped mb-2' width="100%">
                    <thead>
                    <tr>
                      <th> Material</th>
                      <th> Maintenance Images</th>
                      <th> Material Status</th>
                      <th> Maintenance Remark</th>
                      <th> Operation Images</th>
                      <th> Operation Remark</th>
                    </tr>
                    </thead>
                    <tbody>
                    {prevIt.map((value, key3) => {
                      // {console.log(value)}
                      return (
                        <tr key={key3}>
                          <td>{value.material_name}</td>
                          <td>
                            {value?.m_image &&
                              <div className='scrollable-img'>
                                {value.m_image.map((imgdoc, j) => {
                                  return (
                                    <a href={imgdoc} target='_blank'>
                                      {imgdoc.split('.').pop() === 'png' ? <> <img src={imgdoc}
                                                                                   style={{
                                                                                     "width": "80px",
                                                                                     "borderRadius": "8px",
                                                                                     "height": "57px",
                                                                                     "border": "1px solid #555"
                                                                                   }}/> <span className="space"></span> </>:
                                        imgdoc.split('.').pop() === 'jpeg' ? <>  <img src={imgdoc}
                                                                                      style={{
                                                                                        "width": "80px",
                                                                                        "borderRadius": "8px",
                                                                                        "height": "57px",
                                                                                        "border": "1px solid #555"
                                                                                      }}/> <span className="space"></span> </>:
                                          imgdoc.split('.').pop() === 'jpg' ? <> <img src={imgdoc}
                                                                                      style={{
                                                                                        "width": "80px",
                                                                                        "borderRadius": "8px",
                                                                                        "height": "57px",
                                                                                        "border": "1px solid #555"
                                                                                      }}/> <span className="space"></span> </>:
                                            imgdoc.split('.').pop() === 'pdf' ?
                                              <> <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                              imgdoc.split('.').pop() === 'doc' ?
                                                <> <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                                ""
                                      }
                                    </a>
                                  );
                                })}
                              </div>
                            }
                          </td>
                          <td>{value?.m_mat_status}</td>
                          <td>{value?.m_remarks}</td>
                          <td>{value?.ins_remarks}</td>
                          <td>
                            {value?.ins_image &&
                              <>
                                <div className='scrollable-img'>
                                  {value.ins_image.map((imgdoc, j) => {
                                    return (
                                      <a href={imgdoc} target='_blank'>
                                        {imgdoc.split('.').pop() === 'png' ? <> <img src={imgdoc}
                                                                                     style={{
                                                                                       "width": "80px",
                                                                                       "borderRadius": "8px",
                                                                                       "height": "57px",
                                                                                       "border": "1px solid #555"
                                                                                     }}/>  <span className="space"></span> </>:
                                          imgdoc.split('.').pop() === 'jpeg' ? <> <img src={imgdoc}
                                                                                       style={{
                                                                                         "width": "80px",
                                                                                         "borderRadius": "8px",
                                                                                         "height": "57px",
                                                                                         "border": "1px solid #555"
                                                                                       }}/> <span className="space"></span> </>:
                                            imgdoc.split('.').pop() === 'jpg' ? <> <img src={imgdoc}
                                                                                        style={{
                                                                                          "width": "80px",
                                                                                          "borderRadius": "8px",
                                                                                          "height": "57px",
                                                                                          "border": "1px solid #555"
                                                                                        }}/> <span className="space"></span> </> :
                                              imgdoc.split('.').pop() === 'pdf' ? <>
                                                  <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                                imgdoc.split('.').pop() === 'doc' ? <>
                                                    <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </> :
                                                  ""
                                        }
                                      </a>
                                    );
                                  })}
                                </div>
                              </>
                            }
                          </td>

                        </tr>
                      );

                    })}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>
      }

      {/*Previos Hoto Iterations End*/}

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt=""/>
          </div>
          <h5>{modalMsg}</h5>
          <Link
            to={`${baseUrl}/hoto-isite-listing/1`}
            className="btn btn-primary mb-4"
          >
            Go to Listing <img src={Images?.ArrowRight} alt=""/>
          </Link>

        </div>
      </ModalPop>

    </Layout>
  )
    ;
};
HotoInstallForm.propTypes = {
  data: PropTypes.any,
  history: propTypes.any,
};
export default HotoInstallForm;
